"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _index = require("../../index");

var _actions = require("../actions");

var _FindPersonas = _interopRequireDefault(require("../components/FindPersonas"));

var _characteristics = require("../reducers/characteristics");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Actions
// Components
var mapStateToProps = function mapStateToProps(state, props) {
  var workflowPermission = state.options.permissions.workflowPermission;
  return {
    characteristics: (0, _characteristics.getMergedCharacteristics)(state),
    selectedCharacteristics: state.selectedCharacteristics,
    findPersonasSelected: state.findPersonasSelected.records,
    selectedMeasure: state.selectedMeasure.measure,
    hideUnselectedPersonas: state.selectedPersonas.isHidden,
    hasAccess: state.featureAccess.byId && state.featureAccess.byId[workflowPermission] && state.featureAccess.byId[workflowPermission].hasAccess,
    isDataPage: state.options.isDataPage.value
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadCharacteristics: _actions.loadCharacteristics,
    loadSuperSegments: _actions.loadSuperSegments,
    addSelectedPersona: _actions.addSelectedPersona,
    removeSelectedPersona: _actions.removeSelectedPersona,
    toggleSegmentSelectionVisibility: _actions.toggleSegmentSelectionVisibility,
    featureAccess: _index.featureAccess,
    updateSelectedMeasure: _actions.updateSelectedMeasure,
    resetDataPage: _actions.resetDataPage
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FindPersonas["default"]);

exports["default"] = _default;